import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { Logo as LogoComponent } from '../../../Logo'

export const Logo = styled(LogoComponent)`
  margin-bottom: ${Spacing.S12};
`
